import React from "react";
import classnames from "classnames";
import { isIOS } from "utils";
import styles from "../styles.module.scss";

const WeixinMask = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  const isWeixinBrowser = !!ua.match(/MicroMessenger/i);

  if (!isWeixinBrowser) return null;

  return (
    <div
      className={classnames(styles.shadow, {
        [styles.android]: !isIOS(),
      })}
    />
  );
};

export default WeixinMask;
